import { NoSSR } from "@sphtech/web2-core/components";
import {
  CustomContext,
  ResponseType,
  TRouteWithRedirect,
  useRouteContext,
} from "@sphtech/web2-core/ssr";

import ErrorPage from "../StatusHandler/StatusHandler";

export default function OAuthCallbackPage() {
  const routeContext: CustomContext<TRouteWithRedirect<unknown, string>> =
    useRouteContext();
  const dataLoaderResponse = routeContext.context;

  if (dataLoaderResponse.type === ResponseType.SERVER_ERROR) {
    return <ErrorPage response={dataLoaderResponse} />;
  }

  return (
    <NoSSR>
      {/* //Add any custom client side loading screen */}
      <div id="oauth-callback-lb2"></div>
    </NoSSR>
  );
}
